

















































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateTenant from "./create-tenant.vue";
import EditTenant from "./edit-tenant.vue";
import DataInit from "./tenantData.vue";
import ResetPassword from "./resetpassword.vue";
import Moment from "moment-timezone";
import SetApiKey from "./setapikey.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";
import SearchTree from "@/lib/Common/searchtree";

class PageTenantRequest extends PageRequest {
  keyword: string = "";
  isActive: boolean = null;
  Mobile: string = "";
  cityId: number = 0;
}

@Component({
  components: { CreateTenant, EditTenant, DataInit, ResetPassword, SetApiKey },
})
export default class Tenants extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  pagerequest: PageTenantRequest = new PageTenantRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  dataModalShow: boolean = false; //数据初始化
  resetPasswordModalShow: boolean = false; //重置主账号密码
  setapikeyModalShow: boolean = false; //设置密钥
  treedata: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  itemId: string = "0";
  tenantId: number = 0; //租户Id
  splitnum: number = 0.2;
  get list() {
    return this.$store.state.tenant.list;
  }
  get loading() {
    return this.$store.state.tenant.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: string) {
    if (val === "Actived") {
      this.pagerequest.isActive = true;
    } else if (val === "NoActive") {
      this.pagerequest.isActive = false;
    } else {
      this.pagerequest.isActive = null;
    }
  }
  //选中
  handleRowChange(currentRow, oldCurrentRow) {
    this.tenantId = currentRow.id;
  }
  pageChange(page: number) {
    this.$store.commit("tenant/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("tenant/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "tenant/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.tenant.pageSize;
  }
  get totalCount() {
    return this.$store.state.tenant.totalCount;
  }
  get currentPage() {
    return this.$store.state.tenant.currentPage;
  }

  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("TenancyName"),
      key: "tenancyName",
      fixed: "left",
      width: 130,
    },
    {
      title: this.L("Name"),
      key: "name",
      fixed: "left",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      title: this.L("State"),
      fixed: "left",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", params.row.isActive ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: this.L("Mobile"),
      key: "mobile",
      fixed: "left",
      width: 130,
    },
    {
      title: this.L("TenantType"),
      key: "tenantType",
      width: 130,
      render: (h: any, params: any) => {
        let str = this.L("Unknown");
        let id = params.row.tenantType;
        if (id == 1) {
          str = this.L("DataBaseSharing");
        } else if (id == 2) {
          str = this.L("DatabaseExclusive");
        } else if (id == 3) {
          str = this.L("HostExclusive");
        }
        //console.log(str);
        return h("span", str);
      },
    },
    {
      title: this.L("MeterNum"),
      key: "meterNum",
      width: 130,
    },
    {
      title: this.L("EmailAddress"),
      key: "adminEmailAddress",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.adminEmailAddress,
            },
          },
          params.row.adminEmailAddress
        );
      },
    },
    {
      title: this.L("Tel"),
      key: "tel",
      width: 130,
    },
    {
      title: this.L("Contacter"),
      key: "linkMan",
      width: 130,
    },
    {
      title: this.L("WeChat"),
      key: "wechat",
      width: 130,
    },
    {
      title: this.L("TagNo"),
      key: "taxNo",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.taxNo,
            },
          },
          params.row.taxNo
        );
      },
    },
    {
      title: this.L("CompanyAddress"),
      key: "companyAddress",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.companyAddress,
            },
          },
          params.row.companyAddress
        );
      },
    },
    {
      title: this.L("BankName"),
      key: "bankName",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.bankName,
            },
          },
          params.row.bankName
        );
      },
    },
    {
      title: this.L("PayerBankNo"),
      key: "bankNo",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.bankNo,
            },
          },
          params.row.bankNo
        );
      },
    },
    {
      title: this.L("BankAddress"),
      key: "bankAdd",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.bankAdd,
            },
          },
          params.row.bankAdd
        );
      },
    },
    {
      title: this.L("StartDate"),
      key: "startTime",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.startTime == null
            ? ""
            : Moment(params.row.startTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("EndDate"),
      key: "endTime",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.endTime == null
            ? ""
            : Moment(params.row.endTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("OpenTime"),
      key: "openTime",
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.openTime == null
            ? ""
            : Moment(params.row.openTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Salesman"),
      key: "managerId",
      width: 130,
    },
    {
      title: this.L("City"),
      key: "cityId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.cityId;
        let ite = JSON.parse(localStorage.getItem("citys"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Description"),
      key: "description",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.description,
            },
          },
          params.row.description
        );
      },
      width: 130,
    },
    {
      title: this.L("DatabaseConnectionString"),
      key: "connectionString",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.connectionString,
            },
          },
          params.row.connectionString
        );
      },
      width: 130,
    },
    {
      title: this.L("ServerIp"),
      key: "serverIp",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.serverIp,
            },
          },
          params.row.serverIp
        );
      },
      width: 130,
    },
    {
      title: this.L("Port"),
      key: "port",
      width: 130,
    },
    {
      title: this.L("DataBase"),
      key: "dataBase",
      width: 130,
    },
    {
      title: this.L("UserName"),
      key: "uid",
      width: 130,
    },
    {
      title: this.L("Password"),
      key: "passWord",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: "******",
            },
          },
          "******"
        );
      },
    },
    {
      title: this.L("AppKey"),
      key: "appKey",
      width: 190,
    },
    {
      title: this.L("AppSecret"),
      key: "appSecret",
      width: 190,
    },
    {
      title: "Id",
      key: "id",
      width: 190,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        let tenantDel = this.checkButtonAuth('tenantDel');
        let tenantEdit = this.checkButtonAuth('tenantEdit');
        return h("div", [
          tenantDel ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("tenant/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          tenantEdit ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteTenantConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "tenant/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.itemtree();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.treedata = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.treedata = SearchTree.searnchTree(value, treeList);
  }
  async itemtree() {
    await this.$store
      .dispatch("city/getFirstNodeTree")
      .then((val) => {
        this.treedata = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  //获取权限结构Id
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.cityId = item[0].id;
    }
    this.$store.commit("city/setCurrentPage", 1);
    this.getpage();
  }
  //数据初始化
  dataInit() {
    if (this.tenantId == 0) {
      this.$Modal.warning({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    this.dataModalShow = true;
  }
  //重置密码
  resetpassword() {
    if (this.tenantId == 0) {
      this.$Modal.warning({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    this.resetPasswordModalShow = true;
  }
  //设置api密钥
  setappkey() {
    if (this.tenantId == 0) {
      this.$Modal.warning({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("One") + this.L("Record"),
      });
      return;
    }
    this.setapikeyModalShow = true;
  }
}
